import React from 'react';


import {
    Button,
    Flash,
    Form,
    FormSection,
    FormField,
    Input,
    ColumnLayout,
    Table,
    TablePagination,
    TablePropertyFiltering,
    TableSorting,
    Modal,
    Spinner, Icon

} from 'AWS-UI-Components-React';

import {
    JSClient,
    Header
} from '../common';

const filteringOptions = [
    {
        groupValuesLabel: 'InvoiceId Values',
        propertyKey: 'invoiceId',
        propertyLabel: 'Entity Id',
        values: []
    },
    {
        groupValuesLabel: 'Source Values',
        propertyKey: 'source',
        propertyLabel: 'Source',
        values: ['UI', 'Controller', 'DB']
    }
];
const icon = {
    "source":{
    "DB": "lock-private",
    "UI": "view-horizontal",
    "Controller": "settings"}}
export const COLUMN_DEFINITIONS = [{
    id: 'invoiceNumber',
    header: () => 'Entity Id',
    cell: (item) => item.invoiceNumber,
    minWidth: '100px',
    allowLineWrap: false
}, {
    id: 'payeeCode',
    header: () => 'Payee Code',
    cell: (item) => item.payeeCode,
    minWidth: '100px',
    allowLineWrap: false
}, {
    id: 'legalEntity',
    header: () => 'Legal Entity',
    cell: (item) => item.legalEntity,
    minWidth: '100px',
    allowLineWrap: false
},{
    id: 'action',
    header: () => 'Operation',
    cell: (item) => item.action.toLocaleUpperCase(),
    minWidth: '200px',
    allowLineWrap: false
}, {
    id: 'eventTime',
    header: () => 'Event Time',
    cell: (item) => (new Date(parseInt(item.eventTime.toString().substring(0, 13)))).toLocaleString(),
    minWidth: '100px',
    allowLineWrap: false
},  {
    id: 'timeSpent',
    header: () => 'Time Spent in this state (HH:MM:SS:MS)',
    cell: (item) => msToTime(item.timeSpent),
    minWidth: '100px',
    allowLineWrap: false
},{
    id: 'totalTimeSpent',
    header: () => 'Total Time Spent (HH:MM:SS:MS)',
    cell: (item) => msToTime(item.totalTimeSpent),
    minWidth: '100px',
    allowLineWrap: false
},{
    id: 'user',
    header: () => 'System/User',
    cell: (item) => item.user || item.pc_created_by,
    minWidth: '100px',
    allowLineWrap: false
}];

export class FOCInvocieTable extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            unknownloaderror: false,
            initialLoadDone: false,
            user: "",
            approvalLoadDone: true,
            focInvoices: [],
            addBeerOpen: false,
            props: JSON.parse(JSON.stringify(this.props))
        };
        this.clientLoaded = this.clientLoaded.bind(this);
        this.showAddModal = this.showAddModal.bind(this);
        this.hideAddModal = this.hideAddModal.bind(this);
        this.getFOCInvoicesResultHandler = this.getFOCInvoicesResultHandler.bind(this);
        this.handleFilteringInput = this.handleFilteringInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(filter, {detail}) {
        this.state[filter] = detail.value;
        // this.setState(this.state);
        this.client.getFOCInvoices({
            invoiceNumber: this.state.invoiceNumber,
            ...this.props
        }, this.getFOCInvoicesResultHandler);
    }

    clientLoaded() {
        this.client.getIdentity(identityResult => {
            this.setState({...this.state, user: identityResult.username, initialLoadDone: true});
            // this.client.getFOCInvoices({
            //     type: this.state.type,
            //     user: this.state.user, ...this.props
            // }, this.getFOCInvoicesResultHandler);
        });
    }

    componentWillMount() {
        this.client = new JSClient({onReady: this.clientLoaded});
    }

    // componentWillReceiveProps(nextProps, nextContext) {
    //     if (!objectCompare(this.state.props, nextProps)) {
    //         this.setState({...this.state, props: JSON.parse(JSON.stringify(nextProps)), taskLoadDone: false});
    //     }
    // }

    // componentWillUpdate(nextProps, nextState, nextContext) {
    //     if (!nextState.taskLoadDone)
    //         this.client.getFOCInvoices({
    //         type: nextState.type,
    //         user: nextState.user, ...nextProps
    //     }, this.getTasksResultHandler);
    // }

    getFOCInvoicesResultHandler(approvalResult) {
        let invoices=approvalResult.focInvoices;
        invoices.sort(function (a, b) {
            return a.eventTime - b.eventTime;
        });

        var reformattedInvoices = invoices.map((obj, index,arr) =>{
            if(index!=0){
                obj['timeSpent']=obj['eventTime']-arr[index-1]['eventTime'];
                obj['totalTimeSpent']=obj['eventTime']-arr[0]['eventTime'];
            }else{
                obj['timeSpent']=0;
                obj['totalTimeSpent']=0;
            }
            return obj;
        });
        this.setState({focInvoices: reformattedInvoices, approvalLoadDone: true});
    }

    headerCounter(items) {
        return items.length;
    }

    showAddModal() {
        this.setState({addBeerOpen: true});
    }

    hideAddModal() {
        this.setState({addBeerOpen: false});
    }

    handleFilteringInput(e) {
        console.log(e);
    }

    render() {
        if (!this.state.initialLoadDone) {
            return (<div className='offset-xxs-1 col-s-8 offset-l-2 col-xl-3'><Spinner/></div>)
        }
        return (
            <div>
                <div className="awsui-util-container">
                    <div className="awsui-util-container-header">
                        <h2>Events</h2>
                        <div className="awsui-util-container-header-description">
                        </div>
                    </div>
                    <div>
                        <ColumnLayout columns={2} borders="all">
                            <div data-awsui-column-layout-root="true">
                                <FormField label="Entity Id" description="Eg. 66453606444, 66453606127, etc.">
                                    <Input placeholder="Enter Entity Id"
                                           onChange={this.handleInputChange.bind(this, 'invoiceNumber')}/>
                                </FormField>
                            </div>
                        </ColumnLayout>
                        <br/>
                        <Table
                            columnDefinitions={COLUMN_DEFINITIONS}
                            loading={!this.state.approvalLoadDone}
                            resizableColumns={true}
                            items={this.state.focInvoices}
                            empty={<div className="awsui-util-t-c">
                                <div className="awsui-util-pt-l awsui-util-mb-l">
                                    <b>{"Enter entity id to view lifecycle!!"}</b>
                                </div>
                            </div>}
                        >
                            {/*<TableFiltering*/}
                            {/*    filteringPlaceholder="Find events"*/}
                            {/*    filteringText=""*/}
                            {/*    filteringCountTextFunction={count => `${count} ${count === 1 ? 'match' : 'matches'}`}*/}
                            {/*/>*/}
                            <TablePagination/>
                            <TableSorting
                                sortingColumn="variable"
                                sortableColumns={[
                                    {id: "source", field: "source"},
                                    {id: "invoiceId", field: "invoiceId"},
                                    {id: "eventTime", field: "eventTime"}
                                ]}
                            />
                            <TablePropertyFiltering
                                filteringOptions={filteringOptions}
                                groupValuesText="Values"
                                groupPropertiesText="Properties"
                                operationAndText="and"
                                operationNotAndText="and not"
                                operationOrText="or"
                                operationNotOrText="or not"
                                clearFiltersText="Clear filter"
                                placeholder="Filter resources by property or value"
                                allowFreeTextFiltering={true}
                                filteringCountTextFunction={count => `${count} ${count === 1 ? 'match' : 'matches'}`}
                                onFilteringInput={this.handleFilteringInput}
                            />
                        </Table>
                    </div>
                    <div className="awsui-util-container-footer"></div>
                </div>
            </div>
        );
    }
}

function objectCompare(a, b) {
    return JSON.stringify(a) === JSON.stringify(b)
}
function millisToMinutesAndSeconds(millis) {
    var minutes = Math.floor(millis / 60000);
    var seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
}

function msToTime(duration) {
    var milliseconds = parseInt((duration % 1000) / 100),
        seconds = Math.floor((duration / 1000) % 60),
        minutes = Math.floor((duration / (1000 * 60)) % 60),
        hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    return hours + ":" + minutes + ":" + seconds + "." + milliseconds;
}


// WEBPACK FOOTER //
// ./src/components/tables/focinvoices_table.jsx